<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="用户" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入用户昵称/手机号" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="提现方式" prop="withdrawType">
                <a-select v-model="queryParam.withdrawType" placeholder="请选择提现方式" allow-clear>
                  <a-select-option key="1">支付宝</a-select-option>
                  <a-select-option key="2">微信</a-select-option>
                  <a-select-option key="3">银行</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="审核状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择审核状态" allow-clear>
                  <a-select-option key="0">待审核</a-select-option>
                  <a-select-option key="1">审核驳回</a-select-option>
                  <a-select-option key="2">审核通过</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="店铺id" prop="shopId">-->
<!--                <a-input v-model="queryParam.shopId" placeholder="请输入店铺id" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="提现金额" prop="money">
                  <a-input v-model="queryParam.money" placeholder="请输入提现金额" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="实际需要转账金额" prop="realMoney">
                  <a-input v-model="queryParam.realMoney" placeholder="请输入实际需要转账金额" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="提现账号" prop="accountNum">
                  <a-input v-model="queryParam.accountNum" placeholder="请输入提现账号" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="提现账号姓名" prop="accountName">
                  <a-input v-model="queryParam.accountName" placeholder="请输入提现账号姓名" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="提现手续费" prop="serviceChargeNum">
                  <a-input v-model="queryParam.serviceChargeNum" placeholder="请输入提现手续费" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="第三方订单号(微信或支付的交易单号)" prop="orderNo">
                  <a-input v-model="queryParam.orderNo" placeholder="请输入第三方订单号(微信或支付的交易单号)" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="失败原因" prop="failureReason">
                  <a-input v-model="queryParam.failureReason" placeholder="请输入失败原因" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="审核意见" prop="auditOpinion">
                  <a-input v-model="queryParam.auditOpinion" placeholder="请输入审核意见" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="收款二维码" prop="qrCode">
                  <a-input v-model="queryParam.qrCode" placeholder="请输入收款二维码" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="银行名称" prop="bankName">
                  <a-input v-model="queryParam.bankName" placeholder="请输入银行名称" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="银行卡开户行地址" prop="bankAdress">
                  <a-input v-model="queryParam.bankAdress" placeholder="请输入银行卡开户行地址" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:withdrawal:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:withdrawal:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:withdrawal:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['user:withdrawal:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" style="margin-bottom: 20px" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:withdrawal:edit']" v-if="record.status == '0'"  />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.status == '0'" v-hasPermi="['user:withdrawal:edit']">
            <a-icon type="audit" />审核
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['user:withdrawal:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['user:withdrawal:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageWithdrawal,listWithdrawal, delWithdrawal } from '@/api/user/withdrawal'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Withdrawal',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        shopId: null,
        money: null,
        realMoney: null,
        type: null,
        status: undefined,
        accountNum: null,
        accountName: null,
        serviceChargeNum: null,
        withdrawType: undefined,
        withdrawUserType: null,
        orderNo: null,
        failureReason: null,
        auditOpinion: null,
        qrCode: null,
        bankName: null,
        bankAdress: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: '用户',
          dataIndex: 'userId',
          align: 'center',
          customRender(r,t) {
            if(t.nickname) {
              return t.nickname + "("+ t.mobile + ")"
            } else {
              return t.mobile
            }
          }
        },
        // {
        //   title: '店铺id',
        //   dataIndex: 'shopId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '提现方式',
          dataIndex: 'withdrawType',
          ellipsis: true,
          align: 'center',
          customRender(r,t) {
            if(t.withdrawType == 1) {
              return '支付宝'
            } else if(t.withdrawType == 2) {
              return '微信'
            } else if(t.withdrawType == 3) {
              return '银行'
            }
          }
        },
        {
          title: '提现金额',
          dataIndex: 'money',
          align: 'center'
        },
        {
          title: '提现手续费',
          dataIndex: 'serviceChargeNum',
          align: 'center'
        },
        {
          title: '实际需要转账金额',
          dataIndex: 'realMoney',
          align: 'center'
        },
        // {
        //   title: '0-余额 1-保证金',
        //   dataIndex: 'type',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '审核状态',
          dataIndex: 'status',
          align: 'center',
          customRender(r,t) {
            if(t.status == 0) {
              return '未审核'
            } else if(t.status == 1) {
              return '审核驳回'
            } else if(t.status == 2) {
              return '审核通过'
            }
          }
        },
        // {
        //   title: '提现账号',
        //   dataIndex: 'accountNum',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '提现账号姓名',
        //   dataIndex: 'accountName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '提现手续费',
        //   dataIndex: 'serviceChargeNum',
        //   ellipsis: true,
        //   align: 'center'
        // },

        // {
        //   title: '1：普通用户',
        //   dataIndex: 'withdrawUserType',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '第三方订单号(微信或支付的交易单号)',
        //   dataIndex: 'orderNo',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '失败原因',
        //   dataIndex: 'failureReason',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '审核意见',
          dataIndex: 'auditOpinion',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '收款二维码',
        //   dataIndex: 'qrCode',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '银行名称',
        //   dataIndex: 'bankName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '银行卡开户行地址',
        //   dataIndex: 'bankAdress',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '申请时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询用户提现列表 */
    getList () {
      this.loading = true
     pageWithdrawal(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        shopId: undefined,
        money: undefined,
        realMoney: undefined,
        type: undefined,
        status: undefined,
        accountNum: undefined,
        accountName: undefined,
        serviceChargeNum: undefined,
        withdrawType: undefined,
        withdrawUserType: undefined,
        orderNo: undefined,
        failureReason: undefined,
        auditOpinion: undefined,
        qrCode: undefined,
        bankName: undefined,
        bankAdress: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delWithdrawal(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/user-withdrawal/export', {
            ...that.queryParam
          }, `用户提现_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
